// Node Modules
import { nanoid } from 'nanoid';
import { RichText } from 'prismic-reactjs';

// Components
import Button from '@/components/global-components/Button';
import Container from '@/components/global-components/Container';

// Themes
import theme from '@/themes/index';

const AlliancesBanner = ({
  content,
}) => {
  const {
    title = '',
    description = '',
    callToActions = [],
  } = content ?? {};

  return (
    <>
      <div className="container">
        <Container>
          <h2 className="title">{title}</h2>
          <div className="description">
            <RichText render={description} />
          </div>
          <div className='cta-container'>
            {callToActions.map(({
              callToAction: {
                title = '',
                url = '',
                style = '',
              } = {},
            }) =>
              <Button
                key={nanoid()}
                className={style.toLowerCase()}
                text={title}
                href={url}
                tabIndex={0}
                styles={{
                  margin: '3rem auto',
                }}
              />
            )}
          </div>
        </Container>
      </div>
      <style jsx>{`
        h2,
        h6 {
          margin-block-start: 1rem;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        h6 {
          line-height: 1.3rem;
        }

        .container {
          background-color: ${theme.backgroundColors.optional2};
          color: ${theme.fontColors.neutral};
          width: 100%;
          padding: 3rem 1rem;
          height: 32.5rem;
          display: flex;
          align-items: center;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          h6 {
            margin-block-start: 2rem;
          }

          .container {
            padding: 5.5rem 0;
          }
        }
      `}</style>
      <style global jsx>{`
        div.container div.description p {
          font-size: 1.5rem;
          line-height: 2.25rem;
          text-align: center;
        }
      `}</style>
    </>
  );
};

export default AlliancesBanner;
